"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as l } from "react";
import m from "../components/Icon/SvgIcon.js";
const c = (e) => /* @__PURE__ */ o(
  m,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.25 12c0-4.825 3.926-8.75 8.751-8.75S20.75 7.175 20.75 12s-3.925 8.75-8.749 8.75S3.25 16.825 3.25 12M2 12c0 5.514 4.486 10 10.001 10S22 17.514 22 12 17.515 2 12.001 2 2 6.486 2 12m14.446 1.792a5 5 0 0 0 .255-.82l.003-.012c.052-.256.07-.522.08-.79-.022-.27-.118-.496-.36-.566-.67-.194-2.67.354-2.838.873-.168.516 1.128 2.136 1.784 2.373.29.104.536-.107.733-.396.1-.167.2-.334.28-.513l.026-.061zm-6.138 2.256c-.022.697 1.422.708 1.707.708s1.73-.011 1.707-.708c-.023-.698-1.162-2.43-1.707-2.43-.543 0-1.683 1.732-1.707 2.43m-2.847-2.602c.088.27.543 1.642 1.2 1.404.656-.236 1.951-1.856 1.783-2.373-.167-.518-2.167-1.066-2.838-.871-.33.095-.39.476-.357.872l.005.05v.007a4.7 4.7 0 0 0 .207.91m2.99-5.966a4.8 4.8 0 0 0-2.183 1.538c-.13.226-.182.456-.033.649.43.55 2.368 1.283 2.81.963.438-.32.344-2.391-.048-2.97-.123-.18-.324-.212-.547-.18m2.475 4.586a.911.911 0 1 0-1.822.002.911.911 0 0 0 1.822-.002m.6-4.594c-.2-.02-.38.023-.492.189-.393.578-.488 2.65-.048 2.969.44.32 2.38-.413 2.81-.963.13-.168.103-.363.01-.56a4.8 4.8 0 0 0-2.28-1.635M6.05 11.999A5.956 5.956 0 0 1 12 6.049 5.957 5.957 0 0 1 17.951 12a5.96 5.96 0 0 1-5.95 5.952A5.96 5.96 0 0 1 6.051 12",
        clipRule: "evenodd"
      }
    )
  }
), s = l(c);
export {
  s as Tires,
  s as default
};
